import { Alert } from '@mui/material';
import React from 'react';

// https://reactjs.org/docs/error-boundaries.html

export default class ErrorBoundary extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
            error: null
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error: error };
    }

    render() {
        if (this.state.hasError)
            return <Alert severity="error">{this.state.error.toString()}</Alert>;
        return this.props.children ?? null;
    }
}